document.addEventListener("DOMContentLoaded", function () {
    // Collection where the 10% discount applies
    const heatwaveSaleCollection = "heatwave-sale";
    
    // Array of product handles to exclude from the discount
    const excludedHandles = []; // Add any excluded handles here if needed

    // Function to apply a percentage discount
    function applyPercentageDiscount(priceText, discountPercentage) {
        const price = parseFloat(priceText.replace(/[^0-9.]/g, '')); // Extract numeric value
        const discountedPrice = price - (price * discountPercentage / 100);
        return `£${discountedPrice.toFixed(2)}`; // Format as currency
    }

    // Get the current URL path
    const urlParts = window.location.pathname.split("/");

    // Check if the page belongs to any collection
    const isCollectionPage = urlParts.includes("collections");
    const collectionSlug = isCollectionPage ? urlParts[urlParts.indexOf("collections") + 1] : null;
    const isProductPage = urlParts.includes("products");

    if (isCollectionPage && !isProductPage && collectionSlug === heatwaveSaleCollection) {
        // Handle heatwave-sale collection page
        const productCards = document.querySelectorAll(".cl-product-card-inner-container");

        productCards.forEach((card) => {
            // Get the product handle from the link inside the card
            const productLink = card.querySelector("a[href*='/products/']");
            if (productLink) {
                const productHandle = productLink.getAttribute("href").split("/").pop();

                // Skip excluded products
                if (excludedHandles.includes(productHandle)) return;

                const priceElement = card.querySelector(".price-variation");
                if (priceElement) {
                    const currentPriceText = priceElement.textContent;
                    
                    // Apply 10% discount for all products in heatwave-sale collection
                    const discountedPrice = applyPercentageDiscount(currentPriceText, 10);
                    priceElement.textContent = `${discountedPrice} with code HEATWAVE - save extra 10%`;
                }
            }
        });
    }

    if (isCollectionPage && isProductPage && collectionSlug === heatwaveSaleCollection) {
        // Handle product page within heatwave-sale collection
        const productHandle = urlParts[urlParts.indexOf("products") + 1];

        if (!excludedHandles.includes(productHandle)) {
            const priceSnippet = document.querySelector(".product-details-price-snippet .sale-price");
            if (priceSnippet) {
                const currentPriceText = priceSnippet.textContent;
                
                // Apply 10% discount
                const discountedPrice = applyPercentageDiscount(currentPriceText, 10);
                priceSnippet.textContent = `${discountedPrice} with code HEATWAVE - save extra 10%`;
            }
        }
    }
});